export default {
  getControlBookRecordsData: ({ controlBookRecords }) => () => (controlBookRecords),
  getControlBookRecordsTotal: state => state.controlBookRecordsTotal,
  getControlBookInfoData: state => state.controlBookInfo,
  getTokenTransactionsData: ({ tokenTransactions }) => () => (tokenTransactions),
  getTokenTransactionsTotal: state => state.tokenTransactionsTotal,
};
